import Breadcrumbs from 'components/Common/Breadcrumb';
import Loader from 'components/Loader';
import TableError from 'components/TableError';
import useRequest from 'hooks/useRequest';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import {
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Table,
  UncontrolledDropdown,
} from 'reactstrap';
import confirm from 'reactstrap-confirm';

const NcertAiSearch = () => {
  const [ncertAISearchList, setNcertAISearchList] = useState([]);

  const [getCollectionsRequest, { loading: getCollectionsLoading }] = useRequest({
    url: '/ncertaisearch/admin/list-collections',
    method: 'GET',
    onSuccess: (data) => {
      setNcertAISearchList(data);
    },
  });
  const [deleteCollectionRequest, { loading: deleteCollectionLoading }] = useRequest({
    url: '/ncertaisearch/admin/remove-collections',
    method: 'DELETE',
    onSuccess: () => {
      getCollectionsRequest();
    },
  });

  const handleDelete = async (data) => {
    const result = await confirm({
      title: 'Delete Collection',
      message: 'Are you sure, you want to Delete this Collection?',
      confirmText: 'Confirm',
      confirmColor: 'primary',
      cancelColor: 'link text-danger',
    });

    if (result) {
      deleteCollectionRequest({
        data: {
          collectionName: data?._name,
        },
      });
    }
  };

  useEffect(() => {
    getCollectionsRequest();
  }, []);

  return (
    <>
      <div className="page-content">
        <Loader isActive={getCollectionsLoading || deleteCollectionLoading} />

        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="NCERT Books Collection" breadcrumbItem="NCERT Books Collections List" />

          <Row className="mb-2  align-items-center">
            <Col sm="4">
              <div className="search-box me-2 mb-2">
                <div className="position-relative font-bold">{ncertAISearchList?.length} Collections Found</div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg="12">
              <div>
                <div className="table-responsive" style={{ minHeight: 300 }}>
                  <Table className="project-list-table table-nowrap table-centered table-borderless">
                    <thead>
                      <tr className="table-warning">
                        <th scope="col">S.No.</th>
                        <th scope="col">ID</th>
                        <th scope="col">Name</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {!isEmpty(ncertAISearchList) ? (
                        ncertAISearchList?.map((data, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{data?.id}</td>
                            <td>{data?._name}</td>
                            <td className="text-center">
                              <UncontrolledDropdown>
                                <DropdownToggle className="card-drop" tag="a">
                                  <i className="mdi mdi-dots-vertical font-size-18" />
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-end">
                                  <DropdownItem onClick={() => handleDelete(data)}>
                                    <div>
                                      <i className={'mdi mdi-trash-can-outline font-size-16 text-danger me-1'} />{' '}
                                      <span style={{ color: '#212529' }}>Delete</span>
                                    </div>
                                  </DropdownItem>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <TableError />
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default NcertAiSearch;
